export const zh = {
  // 顶部横幅
  banner: {
    text: "全新发布 SafeClaw：更安全、更强大的 OpenClaw 进阶版！",
    date: "（现已上线）"
  },
  
  // 导航栏
  nav: {
    capabilities: "核心能力",
    applications: "应用场景",
    platform: "平台架构",
    contact: "联系我们",
    aboutUs: "关于我们",
    requestAccess: "申请试用",
    languageTooltip: "You can select language here / 这里可以选择语言"
  },
  
  // 首页主区域
  hero: {
    eyebrow: "企业级可信AI智能体",
    title: "为高信任度行业打造可信赖的AI智能体",
    description: "AgentecFusion 是基于香港中文大学研究成果打造的企业级智能体AI平台，专为受监管和数据敏感型行业设计。部署具有证据锚定推理、联邦学习和全面治理的自主智能体。",
    getEarlyAccess: "申请试用",
    contactSales: "联系销售",
    videoNotice: "请耐心等待视频加载，并开启声音（默认静音）",
    videoCaption: "AgentecFusion：为高风险行业打造可信赖的AI智能体"
  },
  
  // 为什么选择 AgentecFusion
  why: {
    title: "为什么选择 AgentecFusion？",
    subtitle: "基于数十年研究，专为企业信任与控制而设计",
    features: [
      {
        title: "可信AI设计",
        points: [
          "证据锚定推理",
          "减少幻觉",
          "明确的安全与治理层"
        ]
      },
      {
        title: "香港中文大学研究驱动",
        points: [
          "30多年研究基础",
          "联邦学习和印记技术",
          "专为高度监管行业设计"
        ]
      },
      {
        title: "企业级控制与安全",
        points: [
          "合规就绪",
          "完整审计与可观测性",
          "基于角色的访问，数据保护"
        ]
      }
    ]
  },
  
  // 应用场景
  applications: {
    title: "应用场景",
    subtitle: "为高风险行业量身定制的AI智能体",
    cases: [
      {
        icon: "✈️",
        title: "旅游业",
        description: "推荐系统让AI智能体根据个人偏好和市场趋势打造个性化旅行体验，提高满意度和预订转化率。"
      },
      {
        icon: "🏦",
        title: "金融业",
        description: "可信AI使智能体能够检测欺诈、避免数据泄露并确保合规——在高需求市场中提供竞争优势。"
      },
      {
        icon: "🎓",
        title: "教育",
        description: "网络智能体在互联网上进行深度研究，将信息综合成定制的、最新的学习模块，超越标准课程。"
      },
      {
        icon: "🎧",
        title: "客户服务",
        description: "情感感知和洞察驱动的智能体处理重复性查询，升级边缘案例，并提供全天候一致质量的支持。"
      }
    ]
  },
  
  // 平台架构
  platform: {
    title: "AgentecFusion 平台架构",
    subtitle: "基于三层研究构建：智能层、可信层和自主智能体层。",
    intelligence: {
      title: "智能层",
      subtitle: "我们研究的坚实基础",
      recommender: {
        title: "推荐系统",
        items: ["深度学习", "混合架构", "强化学习", "多模态推荐", "上下文感知模型"]
      },
      web: {
        title: "网络智能",
        items: ["数据分析", "知识图谱", "迭代检索", "第三方插件", "图神经网络"]
      },
      customer: {
        title: "客户服务智能",
        items: ["持续学习", "情感感知AI", "洞察驱动服务", "多模态与个性化大语言模型"]
      }
    },
    trustworthy: {
      title: "可信层",
      subtitle: "确保安全可靠的AI",
      explainability: {
        title: "可解释性与可理解性",
        items: ["模型水印", "可解释AI框架", "开放策略代理"]
      },
      robustness: {
        title: "鲁棒性与可靠性",
        items: ["AI防火墙", "对抗性去偏", "形式化验证", "模型漂移检测", "数据血缘与溯源"]
      },
      privacy: {
        title: "隐私保护",
        items: ["联邦学习", "同态加密", "差分隐私", "零知识证明"]
      }
    },
    agent: {
      title: "自主智能体层",
      subtitle: "智能自主系统",
      core: {
        title: "智能体核心引擎",
        items: ["规划", "反思", "ReAct", "记忆管理", "分层推理"]
      },
      tooling: {
        title: "工具与环境接口",
        items: ["工具集成", "异常恢复", "任务自动化", "模型上下文协议"]
      },
      orchestration: {
        title: "编排与运维平台",
        items: ["工作流编排", "多智能体协作", "智能体间通信", "数据漂移与模型运维监控"]
      }
    }
  },
  
  // 集成生态
  integration: {
    title: "集成生态系统",
    subtitle: "将 AgentecFusion 与您现有的工具和工作流程连接",
    hubTitle: "AI编排中心",
    customIntegration: "没有看到您的应用？联系我们定制集成。",
    categories: {
      communication: "通讯工具",
      crm: "CRM与销售",
      ai: "AI与机器学习"
    }
  },
  
  // 关于我们
  about: {
    title: "关于我们",
    team: {
      title: "为可信智能体AI而生的团队",
      description: "我们的团队汇聚了40多位专业人士和新兴人才的知识与技能。",
      detail: "我们汇集了在AI平台、教育技术和大规模企业系统方面拥有深厚经验的研究人员、工程师和产品构建者。",
      roles: {
        researchers: "研究人员",
        engineers: "工程师",
        productOps: "产品与运营"
      }
    },
    trackRecord: {
      title: "真实部署中的卓越记录",
      achievements: [
        "我们的CEO设计并实施了联想的企业AI平台（LeapAI），实现了跨行业的可扩展、高性能AI转型。",
        "我们部署的VeriGuide已为亚太、北美和欧洲的4,000多个机构和组织的20万多用户检查了600多万份文档。",
        "我们的平台KEEPCourse支持香港8所大学的15万多用户和1,700多门课程，正常运行时间达99.9%，具有企业级安全性。",
        "我们通过与AT&T、微软、华为、美图和亚马逊等顶级公司的合作，获得了585万港元的技术资助。",
        "我们的AI系统在真实商业环境中提供经过验证的结果，使用与这些合作伙伴共同开发的技术。"
      ],
      products: "以往产品 / 团队经验",
      metrics: {
        users: "注册用户总数",
        institutions: "连接的机构数量"
      },
      partners: "行业合作伙伴"
    },
    industry: {
      title: "深厚的行业经验",
      description: "我们的团队成员曾在全球领先公司工作，带来了技术、金融和电信领域的经验。"
    }
  },
  
  // 联系我们
  contact: {
    title: "准备好转型您的业务了吗？",
    subtitle: "联系我们的团队，讨论 AgentecFusion 如何用AI赋能您的行业",
    aiLead: {
      name: "齐金虎",
      title: "AI研究负责人",
      subtitle: "技术咨询与研究合作"
    },
    vp: {
      name: "Qiudan Wang",
      title: "商务经理",
      subtitle: "商业合作与投资"
    },
    wechat: "微信",
    linkedin: "领英",
    emailLabel: "或直接发送邮件至"
  },
  
  // 页脚
  footer: {
    tagline: "企业级可信AI智能体",
    description: "为高信任度行业构建具有证据锚定推理和全面治理的自主AI智能体。",
    company: {
      title: "公司",
      about: "关于我们",
      careers: "加入我们",
      contact: "联系我们"
    },
    product: {
      title: "产品",
      platform: "平台",
      capabilities: "核心能力",
      applications: "应用场景",
      pricing: "定价"
    },
    resources: {
      title: "资源",
      documentation: "文档",
      blog: "博客",
      caseStudies: "案例研究",
      support: "支持"
    },
    legal: {
      title: "法律",
      privacy: "隐私政策",
      terms: "服务条款",
      security: "安全"
    },
    copyright: "© 2025 AgentecFusion. 保留所有权利。",
    builtWith: "用 ❤️ 为企业AI打造"
  },
  
  // 隐私政策
  privacy: {
    title: "隐私政策",
    lastUpdated: "最后更新",
    section1: {
      title: "我们收集的信息",
      content: "我们收集您直接提供给我们的信息，包括姓名、电子邮件地址、公司信息，以及您在使用我们服务时选择提供的任何其他信息。"
    },
    section2: {
      title: "我们如何使用您的信息",
      content: "我们使用收集的信息来提供、维护和改进我们的服务，与您沟通，并遵守法律义务。"
    },
    section3: {
      title: "数据安全",
      content: "我们实施适当的技术和组织措施，以保护您的个人信息免遭未经授权的访问、更改、披露或销毁。"
    },
    section4: {
      title: "您的权利",
      content: "您有权访问、更正或删除您的个人信息。您也可以反对或限制对您数据的某些处理。"
    },
    contact: {
      title: "联系我们",
      content: "如果您对本隐私政策有任何疑问，请通过以下方式联系我们："
    }
  },
  
  // 服务条款
  terms: {
    title: "服务条款",
    lastUpdated: "最后更新",
    section1: {
      title: "接受条款",
      content: "通过访问和使用 AgentecFusion 服务，您接受并同意受本协议条款和规定的约束。"
    },
    section2: {
      title: "使用许可",
      content: "授予您临时访问 AgentecFusion 服务的权限，仅用于个人、非商业性的临时查看。"
    },
    section3: {
      title: "服务可用性",
      content: "我们努力提供持续的服务可用性，但不保证不间断访问。我们保留随时修改或中止服务的权利。"
    },
    section4: {
      title: "责任限制",
      content: "AgentecFusion 不对因您使用或无法使用服务而导致的任何间接、附带、特殊、后果性或惩罚性损害承担责任。"
    },
    contact: {
      title: "联系我们",
      content: "如有关于这些服务条款的问题，请通过以下方式联系我们："
    }
  },
  
  // SafeClaw 产品页
  safeclaw: {
    hero: {
      badge: "现已发布 · v0.1.1",
      subtitle: "更安全、更强大的 OpenClaw 国产替代方案",
      description: "由香港中文大学专业技术团队联合研发的企业级AI智能体平台。多层安全防护、本地化部署、数据主权完全可控——专为隐私敏感场景设计。",
      download: "立即下载",
      learnMore: "了解更多",
      metaOpen: "开源产品",
      metaSafe: "企业级安全",
      metaCross: "跨平台支持",
      terminalInit: "正在初始化 SafeClaw 环境...",
      terminalSandbox: "WASM + Docker 双沙箱已激活",
      terminalReady: "SafeClaw v0.1.1 就绪",
      terminalStatus: "状态：",
      terminalRunning: "运行中",
      terminalSecurity: "安全等级：",
      terminalMax: "最高级"
    },
    features: {
      title: "核心优势",
      subtitle: "企业级安全架构，专为高信任场景设计",
      items: [
        {
          icon: "🛡️",
          title: "企业级多层防护",
          description: "双沙箱隔离 + 凭据宿主边界注入，确保最高级别的数据安全。",
          points: [
            "WASM + Docker 双沙箱隔离",
            "凭据宿主边界注入",
            "提示注入检测",
            "敏感信息泄露防护"
          ]
        },
        {
          icon: "🚀",
          title: "极简操作体验",
          description: "专为国内用户设计，3步即可上手，无需专业技术知识。",
          points: [
            "全中文图形化一键部署",
            "飞书生态完整支持",
            "内置常用技能包",
            "零命令行门槛"
          ]
        },
        {
          icon: "🏗️",
          title: "自研可控架构",
          description: "核心架构采用 Rust 自研开发，支持本地部署，数据主权完全可控。",
          points: [
            "Rust 核心引擎",
            "本地或云端部署",
            "数据完全留存国内",
            "多模型接入支持"
          ]
        }
      ]
    },
    usecases: {
      title: "应用场景",
      subtitle: "从高效办公到智慧生活，SafeClaw 赋能每一个场景",
      categories: [
        {
          emoji: "💼",
          title: "高效职场伙伴",
          items: [
            "行政管家 — 自动整理日程文件，一键生成工作总结日报",
            "通讯秘书 — 智能管理邮件，快速查找与草拟回复",
            "会议专家 — 自动记录会议内容，精准提炼要点与待办",
            "开发搭档 — 代码助手，协助编写、调试程序",
            "数据分析师 — 快速处理Excel数据，完成分析与报表生成",
            "协同中枢 — 微信、飞书、钉钉多平台信息同步"
          ]
        },
        {
          emoji: "🏠",
          title: "智慧生活助理",
          items: [
            "家居控制官 — 统一管控智能家居设备",
            "全能家教 — 耐心辅导功课，通俗易懂讲解知识点",
            "旅行规划师 — 自动生成完整行程并协助预订",
            "私人健身教练 — 量身定制训练计划和运动提醒",
            "理财顾问 — 分析市场数据，提供投资参考建议",
            "购物参谋 — 自动商品比价、筛选评测推荐"
          ]
        }
      ]
    },
    comparison: {
      title: "SafeClaw vs OpenClaw",
      subtitle: "看看为什么 SafeClaw 是注重安全用户的更优选择",
      header: {
        feature: "功能对比"
      },
      rows: [
        { feature: "安全架构", safeclaw: "企业级多层防护", openclaw: "单层架构", openclawStatus: "no" },
        { feature: "沙箱隔离", safeclaw: "WASM + Docker 双沙箱", openclaw: "无沙箱", openclawStatus: "no" },
        { feature: "凭据保护", safeclaw: "宿主边界注入", openclaw: "存在暴露风险", openclawStatus: "no" },
        { feature: "数据本地化", safeclaw: "完全本地部署", openclaw: "依赖云端", openclawStatus: "partial" },
        { feature: "本地化界面", safeclaw: "全中文图形界面", openclaw: "仅英文", openclawStatus: "no" },
        { feature: "生态集成", safeclaw: "飞书、企微、钉钉", openclaw: "集成有限", openclawStatus: "partial" },
        { feature: "上手难度", safeclaw: "3步快速上手", openclaw: "配置复杂", openclawStatus: "no" },
        { feature: "合规性", safeclaw: "符合个保法与数安法", openclaw: "无本土合规", openclawStatus: "no" }
      ]
    },
    tech: {
      title: "技术架构",
      subtitle: "自研、可控、可扩展",
      items: [
        {
          icon: "🔐",
          title: "安全防护技术栈",
          points: [
            "WASM 沙箱 — 应用层隔离",
            "Docker 沙箱 — 系统层隔离",
            "凭据宿主边界注入",
            "提示注入与泄露检测",
            "配对与白名单访问控制"
          ]
        },
        {
          icon: "🔌",
          title: "开放生态",
          points: [
            "兼容 OpenAI 协议",
            "WASM 工具插件化",
            "WASM 渠道适配",
            "HTTP API 供下游集成",
            "多模型支持（Ollama + 云端）"
          ]
        },
        {
          icon: "☁️",
          title: "灵活部署",
          points: [
            "本地部署 — 数据不离内网",
            "混合部署 — 本地 + 云端协同",
            "多模型故障切换",
            "Routines + Heartbeat 自动化",
            "Web 网关全链路日志"
          ]
        }
      ]
    },
    download: {
      title: "下载 SafeClaw",
      subtitle: "几分钟即可开始使用 SafeClaw — 支持所有主流平台",
      releaseDate: "最新版本 · 2026年4月",
      recommended: "推荐适配您的系统",
      downloadBtn: "下载",
      requirements: {
        title: "系统要求",
        items: [
          "4核或以上 CPU",
          "8GB 及以上内存",
          "推荐 256GB 存储空间",
          "macOS 12+、Windows 10+ 或 Ubuntu 20.04+"
        ]
      }
    },
    pricing: {
      title: "选择适合您的方案",
      subtitle: "从个人探索到企业部署 — 每个阶段都有合适的选择",
      popular: "最受欢迎",
      plans: [
        {
          name: "社区版",
          price: "¥0",
          period: "",
          originalPrice: null,
          featured: false,
          description: "适合个人用户和开发者，在安全的本地环境中体验AI智能体。",
          features: [
            "1 个安全智能体实例",
            "支持本地部署",
            "WASM 沙箱隔离",
            "社区支持",
            "按量计费 Token 使用"
          ],
          cta: "免费开始"
        },
        {
          name: "成长版",
          price: "¥100",
          period: "/月",
          originalPrice: null,
          featured: true,
          description: "高效 AI 工作流所需的一切，扩展容量与优质 Token 额度。",
          features: [
            "最多 2 个智能体实例",
            "每月 1300万 Token 额度",
            "Docker + WASM 双沙箱",
            "飞书生态集成",
            "Token 额度池共享",
            "邮件技术支持"
          ],
          cta: "开启成长版"
        },
        {
          name: "企业版",
          price: "¥1,000",
          period: "/月",
          originalPrice: null,
          featured: false,
          description: "全面部署方案，具备高级安全、大容量 Token 与专属团队支持。",
          features: [
            "最多 5 个智能体实例",
            "每月 1.3亿 Token 额度",
            "完整安全防护套件",
            "多平台生态集成",
            "优先技术支持",
            "定制化技能包"
          ],
          cta: "联系销售"
        }
      ]
    }
  }
};
